var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-data-table',{attrs:{"loading":_vm.loading,"headers":_vm.headers,"items":_vm.items,"disable-pagination":"","hide-default-footer":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }